import { combinedApi as api } from "../combinedApi";
export const addTagTypes = ["Configuration"] as const;
const injectedRtkApi = api
  .enhanceEndpoints({
    addTagTypes,
  })
  .injectEndpoints({
    endpoints: (build) => ({
      getConfiguration: build.query<
        GetConfigurationApiResponse,
        GetConfigurationApiArg
      >({
        query: (queryArg) => ({
          url: `/Configuration`,
          params: { name: queryArg.name, category: queryArg.category },
        }),
        providesTags: ["Configuration"],
      }),
      postConfiguration: build.mutation<
        PostConfigurationApiResponse,
        PostConfigurationApiArg
      >({
        query: (queryArg) => ({
          url: `/Configuration`,
          method: "POST",
          body: queryArg,
        }),
        invalidatesTags: ["Configuration"],
      }),
      putConfigurationById: build.mutation<
        PutConfigurationByIdApiResponse,
        PutConfigurationByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/Configuration/${queryArg.id}`,
          method: "PUT",
          body: queryArg.configurationDto,
        }),
        invalidatesTags: ["Configuration"],
      }),
      deleteConfigurationById: build.mutation<
        DeleteConfigurationByIdApiResponse,
        DeleteConfigurationByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/Configuration/${queryArg}`,
          method: "DELETE",
        }),
        invalidatesTags: ["Configuration"],
      }),
    }),
    overrideExisting: false,
  });
export { injectedRtkApi as configurationApi };
export type GetConfigurationApiResponse =
  /** status 200 OK */ ConfigurationDto[];
export type GetConfigurationApiArg = {
  name: string;
  category: string;
};
export type PostConfigurationApiResponse = /** status 201 Created */ number;
export type PostConfigurationApiArg = ConfigurationDto;
export type PutConfigurationByIdApiResponse = /** status 200 OK */ void;
export type PutConfigurationByIdApiArg = {
  id: number;
  configurationDto: ConfigurationDto;
};
export type DeleteConfigurationByIdApiResponse = unknown;
export type DeleteConfigurationByIdApiArg = number;
export type ConfigurationDto = {
  id: number;
  category: string;
  name: string;
  value: string;
  isDefault: boolean;
};
export type ProblemDetails = {
  type?: string | null;
  title?: string | null;
  status?: number | null;
  detail?: string | null;
  instance?: string | null;
  [key: string]: any;
};
export const {
  useGetConfigurationQuery,
  useLazyGetConfigurationQuery,
  usePostConfigurationMutation,
  usePutConfigurationByIdMutation,
  useDeleteConfigurationByIdMutation,
} = injectedRtkApi;
